<template>
  <bsp-dialog :title="$t('homepage.txt032')" :dialogVisible.sync="visible" top="15vh" @closeButton="closeDialog" width="60%"><!-- 选择票据 -->
    <template #body v-loading="loading">
      <div class="flexTable">
        <el-carousel class="userHelpCarousel" indicator-position="outside" :autoplay='autoplay' arrow="always" trigger="click">
          <el-carousel-item><el-image class="userHelpImg" :src="img1Url" title="1"></el-image></el-carousel-item>
          <el-carousel-item><el-image class="userHelpImg" :src="img2Url" title="2"></el-image></el-carousel-item>
          <el-carousel-item><el-image class="userHelpImg" :src="img3Url" title="3"></el-image></el-carousel-item>
          <el-carousel-item><el-image class="userHelpImg" :src="img4Url" title="4"></el-image></el-carousel-item>
          <el-carousel-item><el-image class="userHelpImg" :src="img5Url" title="5"></el-image></el-carousel-item>
        </el-carousel>
      </div>
    </template>
<!--    <div class="dialog-footer" slot="footer">-->
<!--      <el-button @click="closeDialog">{{$t('cost.cost058')}}</el-button>&lt;!&ndash; 取  消 &ndash;&gt;-->
<!--      <el-button type="primary" @click="submit">{{$t('cost.cost103')}}</el-button>&lt;!&ndash; 添加至报销单 &ndash;&gt;-->
<!--    </div>-->
  </bsp-dialog>
</template>

<script>

import { getUserCusList, getUserCusListZz, getAllCusList} from "@/api/sys/cus";
import { getCloudCostDetailMobileList } from "@/api/cost/cost";

import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import BspDictsSelect from '@/components/bsp/bsp-dicts-select/bsp-dicts-select'
import { downloadFile } from '@/util/util'
import {mapGetters} from 'vuex';
import img1 from "@/assets/img/userHelp/1.png";
import img2 from "@/assets/img/userHelp/2.png";
import img3 from "@/assets/img/userHelp/3.png";
import img4 from "@/assets/img/userHelp/4.png";
import img5 from "@/assets/img/userHelp/5.png";
import {formatDateSubstr10, formatDateSimple} from "@/util/date_format.js"


export default {
  name: "userHelp",
  components: { BspDialog },
  props:{
    optParams: {
      type: Object,
      default: function (){
        return {
        };
      },
    },
  },
  data() {
    return {
      searchForm:{},
      searchParams: {},
      demoLoading: true,
      visible: false,
      autoplay: false,
      img1Url: img1,
      img2Url: img2,
      img3Url: img3,
      img4Url: img4,
      img5Url: img5,
    };
  },
  created() {

  },
  mounted(){

  },
  methods: {

    init() {
      // if(this.$route.query.from){
      //   alert(this.$route.query.tdStatus);
      // }
      // var user = this.$store.state.user.userInfo;
      // this.userId = user.userId;
    },
    submit(){
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        return this.$message.error(this.$t('homepage.txt027')) //至少选择一条数据
      }

      var that = this;
      this.$confirm(
        this.$t('cost.cost105'), // 是否确认将所选票据添加至报销单
        this.$t("homepage.txt017"), //提示
        {
          type: 'warning'
        }
      ).then(function(){
        //确认操作
        console.log("1111122")
        let ids =that.multipleSelection.map(item=> item.id)
        console.log("pickInvoice submit:" + ids);
        that.$emit('reload', that.multipleSelection);
        that.clearForm();
        that.visible = false;
      }).then((data) => {
        //取消操作
      }).catch(function (err) {
        //捕获异常
      });
    },

    closeDialog () {
      this.visible = false;
      this.clearForm();
      if(this.optParams && this.optParams.firstFlag){
        this.$emit('reload');
      }
      // const that = this;
      // this.$confirm(
      //   '是否放弃当前操作！',
      //   '提示',
      //   {
      //     type: 'warning'
      //   }
      // ).then(function(){
      //   //确认操作
      //   that.clearForm();
      //   that.visible = false;
      // }).then((data) => {
      //   //取消操作
      // }).catch(function (err) {
      //   //捕获异常
      // });

    },
    close (){
      this.clearForm();
      this.visible = false;
    },
    clearForm(){

    },
    isNotBlank(str){
      if(str == null || str ==undefined || str == ''){
        return false;
      }else{
        return true;
      }
    }
  },
  destroyed(){
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts']),
  }
};
</script>

<style lang="scss">
.userHelpImg{
  width:100%;
  height: 100%;
}
.userHelpCarousel {
  height: 560px; /* 你可以根据需要设置具体的高度 */
}
.userHelpCarousel .el-carousel__container {
  height: 90%; /* 确保容器也填满整个高度 */
}
.userHelpCarousel .el-carousel__item {
  height: 90%; /* 确保每个项目也填满整个高度 */
}
</style>
